import { Component } from '@angular/core';

@Component({
    selector: 'sh-dummy',
    template: '',
    standalone: true
})
export class ShDummyContainerComponent {}
